import { render, staticRenderFns } from "./HotCategory.vue?vue&type=template&id=4db73fd8&scoped=true&"
import script from "./HotCategory.vue?vue&type=script&lang=js&"
export * from "./HotCategory.vue?vue&type=script&lang=js&"
import style0 from "./HotCategory.vue?vue&type=style&index=0&id=4db73fd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db73fd8",
  null
  
)

export default component.exports